
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { MapPin } from "lucide-react";
import { Control } from 'react-hook-form';
import { z } from 'zod';

// Schema for address details
export const addressSchema = z.object({
  street: z.string().min(3, "Podaj prawidłową nazwę ulicy"),
  buildingNumber: z.string().min(1, "Podaj numer budynku"),
  apartmentNumber: z.string().optional(),
  city: z.string().min(2, "Podaj prawidłową nazwę miasta"),
  postalCode: z.string().regex(/^\d{2}-\d{3}$/, "Kod pocztowy musi być w formacie XX-XXX"),
});

export type AddressValues = z.infer<typeof addressSchema>;

interface AddressSectionProps {
  control: Control<any>;
}

const AddressSection: React.FC<AddressSectionProps> = ({ control }) => {
  return (
    <div>
      <div className="flex items-center space-x-2 mb-4">
        <MapPin className="h-5 w-5 text-gray-500" />
        <h3 className="text-lg font-medium">Adres instalacji</h3>
      </div>
      
      <div className="grid grid-cols-1 gap-4">
        <FormField
          control={control}
          name="street"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Ulica</FormLabel>
              <FormControl>
                <Input placeholder="Marszałkowska" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <div className="grid grid-cols-2 gap-4 mt-4">
        <FormField
          control={control}
          name="buildingNumber"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Numer budynku</FormLabel>
              <FormControl>
                <Input placeholder="42" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={control}
          name="apartmentNumber"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Numer mieszkania (opcjonalnie)</FormLabel>
              <FormControl>
                <Input placeholder="15" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          control={control}
          name="city"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Miasto</FormLabel>
              <FormControl>
                <Input placeholder="Warszawa" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={control}
          name="postalCode"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Kod pocztowy</FormLabel>
              <FormControl>
                <Input placeholder="00-123" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default AddressSection;
